// extracted by extract-css-chunks-webpack-plugin
module.exports = {"thumbnail":"thumbnail___2vCld","wrapper":"wrapper___37XZf","image":"image___RLK7i","active":"active___PCoww","item-card":"item-card___1bBHa"};